import React from 'react'
import CounterOption from '../CounterOption/CounterOption'

export default function CounterGroup(props) {
	return (
		<div>
			{props.optionGroup.options.map((option, idx) => <CounterOption key={props.optionGroup._id} option={option} groupId={props.optionGroup._id}></CounterOption>)}
		</div>
	)
}
